import { UseMutationOptions, useMutation } from '@tanstack/react-query'

import { HttpError } from '@/api/http'

import { patchUser, deleteUser, acceptLegalDocuments } from './services'

import {
  PatchUserPayload,
  PatchUserResponse,
  DeleteUserPayload,
  DeleteUserResponse,
  AcceptLegalDocumentsPayload,
  AcceptLegalDocumentsResponse,
} from './types'

export const useMutationPatchUser = (options?: UseMutationOptions<PatchUserResponse, HttpError, PatchUserPayload>) => {
  return useMutation({ ...options, mutationFn: patchUser })
}

export const useMutationDeleteUser = (
  options?: UseMutationOptions<DeleteUserResponse, HttpError, DeleteUserPayload>
) => {
  return useMutation({ ...options, mutationFn: deleteUser })
}

export const useMutationAcceptLegalDocuments = (
  options?: UseMutationOptions<AcceptLegalDocumentsResponse, HttpError, AcceptLegalDocumentsPayload>
) => {
  return useMutation({ ...options, mutationFn: acceptLegalDocuments })
}
